var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 14.6667V1.33337V14.6667Z",
    fill: "#673E9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00012 14.6667V1.33337",
    stroke: "#673E9B",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 8.00012H14.6667H1.33337Z",
    fill: "#673E9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 8.00012H14.6667",
    stroke: "#673E9B",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.2f4f1ddd5e99c718d3f9c9653a031a70.svg";
export { ForwardRef as ReactComponent };